import { useLoaderData } from "react-router-dom";
import { interactiveURL } from '../config';
import {
  useAppSelector,
  coverSelector,
} from '../store';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCirclePlay,
} from '@fortawesome/pro-solid-svg-icons';

import './Cover.scss';

export default function Cover({ coverType }: { coverType:string|null }) {

  const {
    isVr,
    viewId,
    layerId,
    spaceId,
    openSpace,
    openCategory,
  } = useLoaderData() as {
    isVr:boolean,
    viewId:string,
    layerId:string,
    spaceId:string,
    openSpace:string,
    openCategory:string,
  };
  const {
    orderPermalink,
    mapId,
    vrId,
    splashImage,
    bgImage,
    title,
    subtitle,
  } = useAppSelector(coverSelector);

  const appUrl = () => {
    let url = `${interactiveURL}/${orderPermalink}`;
    if (isVr) {
      url += `/${vrId}`;
      if (viewId) {
        url += `/view/${viewId}`;
      }
    } else {
      url += `/map/${mapId}`;
      if (layerId) {
        url += `/layer/${layerId}`;
        if (spaceId) {
          url += `/space/${spaceId}`;
          if (openSpace) {
            url += '/open';
          }
        } else if (openCategory) {
          url += `/cat/${openCategory}`;
        }
      } else if (openCategory) {
        url += `/cat/${openCategory}`;
      }
    }
    return url;
  };

  const coverContent = () => {
    if (coverType === 'basic') {
      return (
        <div className="overlay-content">
          <div className="order-name">
            { title }
          </div>
          <div className="name">
            { subtitle }
          </div>
          <div className="play">
            <FontAwesomeIcon icon={ faCirclePlay } />
          </div>
        </div>
      );

    } else { // branded
      return (
        <>
          <div className="overlay-image">
            <img
              className="order-name"
              src={splashImage}
              alt="logo"
            />
          </div>
          <p className="subtitle">
            { isVr ? "Open Virtual Tour" : "Open Interactive Map" }
          </p>
        </>
      );
    }
  };

  return (
    <a
      className="cover"
      href={appUrl()}
      target="_blank"
      rel="noreferrer"
    >
      <div
        className="image"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="overlay">
          { coverContent() }
          <img
            className="visrez-logo"
            src={`${interactiveURL}/icons/visrez-logo-text-white.svg`}
            alt="Visrez"
          />
        </div>
      </div>
    </a>
  );
}
